import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FamilyCodeTransmissionService } from '../../../services/raintree/Transmission/familyCode-transmission.service';
import { FamilyCodeResponseObj } from '../../../services/raintree/interfaces/family-code.interface';
import { ToastrService } from 'ngx-toastr';
import { CommonUtilService } from '../../../services/common-util/common-util.service';
import { MatDialog } from '@angular/material/dialog';
import { FcCodePopupComponent } from '../../../views/common/dpnf/fc-code-popup/fc-code-popup.component';

@Component({
  selector: 'app-verify-fc',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
  ],
  templateUrl: './verify-fc.component.html',
  styleUrl: './verify-fc.component.scss'
})
export class VerifyFcComponent {
  
  
  fcLengthError=false;
  showMembers=false;
  loading=false;
  apiError=false;

  @Input() dpName!:string;
  @Input() familyCode!:string;
  @Input() fcMembers!:any[];
  @Input() selectedMemKey!:string|null;
  @Output() selectedMemberKey:EventEmitter<string|null>=new EventEmitter();
  @Output() familyMembers:EventEmitter<FamilyCodeResponseObj[]>=new EventEmitter();
  @Output() step:EventEmitter<number>=new EventEmitter();

  constructor(
    public dialog:MatDialog,
    public commonUtil:CommonUtilService,
    private _fcTransmissionService:FamilyCodeTransmissionService,
    public toaster:ToastrService
  ){}

  ngOnInit(){
    if(this.fcMembers.length>0){
      this.showMembers=true;
      this.familyCode=this.fcMembers[0].mem_family_code;
    }
    else if(this.familyCode){
      this.verifyFC();
    }
  }

  verifyFC(){
    // this.output=this.familyCode;
    if(!this.familyCode||this.familyCode.length!==12){
      this.fcLengthError=true;
      return;
    }
    this.fcMembers=[]
    this.showMembers=true;
    this.loading=true;
    
    this._fcTransmissionService.getFamilyDetails(this.familyCode).subscribe({//change from number to string
      next:(response:any)=>{
        
        if (response.error) {
          this.toaster.error(response.message,'Error');
          this.loading=false;
          this.apiError=true;
        }
        else{
          console.log(response.data);
          
          this.fcMembers=response.data.filter((member:any)=>member.mem_last_transaction_date!==0);
          this.familyMembers.emit(this.fcMembers);
          this.loading=false;
        }
      },
      error:error=>{
        this.toaster.error(error,'Error');
        this.loading=false;
        this.apiError=true;
      }
    });
  }

  removeFamilyMembers(){
    if(this.familyCode.length<12){
      this.fcMembers=[];
      this.selectedMemKey=''
      this.showMembers=false;
      this.selectedMemberKey.emit(this.selectedMemKey);
      this.familyMembers.emit(this.fcMembers);
    }
  }

  onKeydown(event:KeyboardEvent){
    if(event.key.match(/^[0-9]$/)===null){
      if(event.key!=='Backspace'){
        if(event.key!=='ArrowRight'){
          if(event.key!=='ArrowLeft')
            event.preventDefault();
        }
      }
    }
  }

  memKeyNull(){
    
    this.selectedMemKey=null;
    this.selectedMemberKey.emit(this.selectedMemKey);
  }

  private openDialogAndHandleResponse(index:number): void {
      const dialogRef = this.dialog.open(FcCodePopupComponent);
      dialogRef.afterClosed().subscribe((value) => {
        if (value) {
          this.selectedMemKey=this.fcMembers[index].mem_key;
          this.selectedMemberKey.emit(this.selectedMemKey);
        } 
        else {
          this.selectedMemKey=null;
        }
      });
  }

  emitSelectedMemKey(index:number){

    let member=this.fcMembers[index];
    let phlFullName=member.mem_name+' '+member.mem_surname;

    if (phlFullName !== this.dpName) {
      this.openDialogAndHandleResponse(index);
    }
    else {
      this.selectedMemKey=this.fcMembers[index].mem_key;
      this.selectedMemberKey.emit(this.selectedMemKey);
    }
  }
}
